export const listDays = [
	{ id: 1, label: 'S', value: 'sunday' },
	{ id: 2, label: 'M', value: 'monday' },
	{ id: 3, label: 'T', value: 'tuesday' },
	{ id: 4, label: 'W', value: 'wednesday' },
	{ id: 5, label: 'T', value: 'thursday' },
	{ id: 6, label: 'F', value: 'friday' },
	{ id: 7, label: 'S', value: 'saturday' }
]
